export default __webpack_public_path__ + "static/media/A5_31.a54545e5.mp3";